// extracted by mini-css-extract-plugin
export default {"section":"Wedding_section__cT3mH","container":"Wedding_container__DyLJR","container__photo":"Wedding_container__photo__y31WZ","photo":"Wedding_photo__YT2ql"};